import { PageShell } from '@heidi/design-system/page-shell';
import {
  hasIntegrationAtom,
  integrationOptionsAtom,
} from '@heidi/integrations/ehr/data/atoms';
import { useIsMobile } from '@heidi/utils';
import { useAtom, useAtomValue } from 'jotai';
import { memo } from 'react';
import { SideNav } from '../../Navigation/SideNav';
import { isMobileHeaderSheetOpenAtom } from './mobile-header-sheet-atoms';

/**
 * Mobile sidebar drawer content with iOS-style panel navigation.
 *
 * Uses PageShell.MobileSidebar which encapsulates:
 * - Vaul bottom drawer for consistent mobile UX
 * - SidebarProvider for sidebar primitives (SidebarMenuButton, etc.)
 * - PanelProvider for iOS-style slide animations between sidebar and panel views
 */
const MobileHeaderSheetContent = memo(() => {
  const hasIntegration = useAtomValue(hasIntegrationAtom);
  const integrationOptions = useAtomValue(integrationOptionsAtom);
  const [isOpen, setIsOpen] = useAtom(isMobileHeaderSheetOpenAtom);
  const isMobile = useIsMobile();

  return (
    <PageShell.MobileSidebar
      open={isOpen && isMobile}
      onOpenChange={setIsOpen}
      className={
        hasIntegration && integrationOptions.banner
          ? 'max-h-[calc(100vh-40px)]'
          : undefined
      }
    >
      <SideNav />
    </PageShell.MobileSidebar>
  );
});

MobileHeaderSheetContent.displayName = 'MobileHeaderSheetContent';
export default MobileHeaderSheetContent;
